<template>
    <div class="container remove-padding-margin" id="listparfum">
        <div class="fixed-judul fixed-top">
            <div class="row justify-content-center align-items-center set-row showPageDefault">
                <div class="col-md-3 col-sm-3 col-3 remove-padding">
                    <img @click="back" src="../../assets/gambar/back-blue.svg" alt="">
                </div>
                <div class="col-md-6 col-sm-6 col-6 text-center remove-padding">
                    <h6 class="remove-margin font-16 font-colorcheck text-promo">Daftar Jenis Parfum</h6>
                </div>
                <div class="col-md-3 col-sm-3 col-3 remove-padding">
                    <img class="imageSearch" src="../../assets/icons/search.svg" v-on:click="showSearch" alt=""
                        id="iconsearch">
                </div>
            </div>
            <div class="row justify-content-center align-items-center set-row showPageSearch">
                <div class="col-md-9 col-sm-9 col-9 remove-padding">
                    <input class="inputSearch" id="input_search_parfume" type="text" v-on:keyup="searchRak"
                        v-model="searchKey" placeholder="Cari..">
                </div>
                <div class="col-md-3 col-sm-3 col-3 remove-padding">
                    <img class="imageSearch" v-on:click="closeSearch" src="../../assets/img/x2.svg" alt="">
                </div>
            </div>
        </div>

        <main class="add-padding-default bg-gray" id="list-search-parfum">
            <div class="flex-100 showPageSearch">
                <div id="list-search-parfum-scrolled" style="height: 100vh; overflow-y: auto">
                    <div class="flex-1" v-if="parfumsearch.length >= 0">
                        <div class="Search-BOX mar-top-60 mar-bottom-16" id="textTopParfum"></div>
                        <div class="">
                            <div class="row set-card" v-for="(ps,k) in parfumsearch" :key="ps.idparfum">
                                <div class="col-md-9 col-sm-9 col-9 text-left remove-padding">
                                    <h6 class="f-16 align-items-center remove-margin f-semi" style="line-height: 21px"
                                        v-html="searchHighlight(ps.nama_parfum, searchKey)"></h6>
                                    <p class="m-t-4 mb-0 f-14 f-c-midgrey" v-if="ps.parfum_default">
                                        <img src="../../assets/img/loader.svg" alt="" class="m-r-4"
                                            style="height: 14px; width: 14px">
                                        Parfum Utama
                                    </p>
                                </div>
                                <div class="col-md-3 col-sm-3 col-3 text-right remove-padding dropdown"
                                    id="dropdownMenuLink" :data-toggle="validateAccess('perfume.update') && 'dropdown'" aria-haspopup="true"
                                    aria-expanded="false">
                                    <img src="../../assets/icons/more-horizontal2.svg" alt="">
                                    <div class="dropdown-menu garis-parfum" aria-labelledby="dropdownMenuLink">
                                        <a class="dropdown-item icon-1" href="#" @click="modaledit(ps,k)" v-if="validateAccess('perfume.update')"><span
                                                class="mar-right-10"><i
                                                    class="far fa-edit color-206CF"></i></span>Ubah</a>
                                        <a class="dropdown-item icon-2" href="#" @click="modaldel(ps,k)" v-if="validateAccess('perfume.delete')"><span
                                                class="mar-right-10"><img
                                                    src="../../assets/icons/trash-2.svg"></span>Hapus</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="loadmoreSpinner" id="loadingSpinnerParfumSearch" style="display: none">
                            <center>
                                <div class="sp sp-circle"></div>
                            </center>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex-100 showPageDefault">
                <div class="flex-1" v-if="parfum.lenght_data === 0">
                    <div class="image text-alignC">
                        <img class="img-fluid" src="../../assets/icons/Hanger.svg" alt="">
                        <h5 class="text-center">Belum ada jenis parfum yang terdaftar</h5>
                        <h6 class="text-center">Silahkan klik tombol + untuk menambahkan</h6>
                    </div>
                </div>
                <div class="flex-1" v-else>
                    <div class="card-2">
                        <h6>Total {{parfumLength}} Parfum</h6>
                        <FilterSorting :jenisFilter="'parfum'" :sortByColumn="'nama_parfum'" @filter="filter" />
                        <br>
                        <div class="row set-card" v-for="(p,k) in parfum" :key="p.idparfum">
                            <div class="col-md-9 col-sm-9 col-9 text-left remove-padding">
                                <h6 class="f-16 align-items-center remove-margin f-semi" style="line-height: 21px">
                                    {{p.nama_parfum}}</h6>
                                <p class="m-t-4 mb-0 f-14 f-c-midgrey" v-if="p.parfum_default === 1">
                                    <img src="../../assets/img/loader.svg" alt="" class="m-r-4"
                                        style="height: 14px; width: 14px">
                                    Parfum Utama
                                </p>
                            </div>
                            <div class="col-md-3 col-sm-3 col-3 text-right remove-padding dropdown"
                                id="dropdownMenuLink" :data-toggle="validateAccess('perfume.update') && 'dropdown'" aria-haspopup="true" aria-expanded="false">
                                <img src="../../assets/icons/more-horizontal2.svg" alt="">
                                <div class="dropdown-menu garis-parfum" aria-labelledby="dropdownMenuLink">
                                    <a class="dropdown-item icon-1" href="#" @click="modaledit(p,k)" v-if="validateAccess('perfume.update')"><span
                                            class="mar-right-10"><i class="far fa-edit color-206CF"></i></span>Ubah</a>
                                    <a class="dropdown-item icon-2" href="#" @click="modaldel(p,k)" v-if="validateAccess('perfume.delete')"><span
                                            class="mar-right-10"><img
                                                src="../../assets/icons/trash-2.svg"></span>Hapus</a>
                                </div>
                            </div>
                        </div>
                        <div class="loadmoreSpinner" id="loadingSpinnerParfum" style="display: none">
                            <center>
                                <div class="sp sp-circle"></div>
                            </center>
                        </div>
                    </div>
                    <div class="flying-button-wrapper" v-if="validateAccess('perfume.create')">
                        <div class="flying-inside">
                            <div class="flying-button btn-add-outlet" data-toggle="modal" data-target="#addmodal"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="addmodal" role="dialog">
                <div class="modal-dialog modal-lg  bani-modal">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="nav-btn kiri"></div>
                            <h5 class="navbar-title text-center">Tambah Jenis Parfum</h5>
                            <div class="nav-btn kanan tutup" @click="closeModalAdd">
                                <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                            </div>
                        </div>
                        <div class="modal-body">
                            <label class="remove-margin mar-top-12 require" for="namaperfume">Nama Parfum</label>
                            <input type="text" class="form-control inputs" id="namaperfume" placeholder="Downey"
                                v-model="namaperfume">
                            <ErrorMessage class="error" label="Nama Parfum" :validation="$v.namaperfume" ref="errmsg"></ErrorMessage>
                            <div class="custom-control custom-checkbox remove-padding m-t-16">
                                <input type="checkbox" class="custom-control-input" id="create_default_parfum">
                                <label class="custom-control-label font-colorcheck f-16" for="create_default_parfum">
                                    Atur sebagai parfum utama
                                </label>
                                <p class="m-t-12 mb-0 f-14 f-c-midgrey">
                                    Parfum akan otomatis terpilih saat kasir membuat transaksi baru.
                                </p>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-primary btn-long" @click="addparfum">Simpan
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="editmodal" role="dialog">
                <div class="modal-dialog modal-lg  bani-modal">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="nav-btn kiri"></div>
                            <h5 class="navbar-title text-center">Ubah Jenis Parfum</h5>
                            <div class="nav-btn kanan tutup">
                                <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                            </div>
                        </div>
                        <div class="modal-body">
                            <label class="remove-margin mar-top-12 require" for="nameperfume">Nama Parfum</label>
                            <input type="text" class="form-control inputs" id="nameperfume" placeholder="Downey"
                                v-model="namaperfume">
                            <ErrorMessage class="error" label="Nama Parfum" :validation="$v.namaperfume"></ErrorMessage>
                            <div class="custom-control custom-checkbox remove-padding m-t-16">
                                <input type="checkbox" class="custom-control-input" id="edit_default_parfum">
                                <label class="custom-control-label font-colorcheck f-16" for="edit_default_parfum">
                                    Atur sebagai parfum utama
                                </label>
                                <p class="m-t-12 mb-0 f-14 f-c-midgrey">
                                    Parfum akan otomatis terpilih saat kasir membuat transaksi baru.
                                </p>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-primary btn-long" @click="editparfum">Simpan
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="deletemodalperfume" role="dialog">
                <div class="modal-dialog modal-lg  bani-modal">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="nav-btn kiri"></div>
                            <h5 class="navbar-title text-center">Hapus Jenis Parfum</h5>
                            <div class="nav-btn kanan tutup">
                                <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                            </div>
                        </div>
                        <div class="modal-body">
                            <p class="font-14 remove-padding-margin">Apakah anda yakin ingin menghapus parfum
                                <b>{{namaperfume}}?</b></p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal"
                                @click="delparfum">Hapus
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    import FilterSorting from "@/component-items/FilterSorting";
    import ErrorMessage from "@/component-items/ErrorMessage";
    import {
        minLength,
        required
    } from "vuelidate/lib/validators";

    export default {
        name: "DataPerfume",
        props: ['setidoutlet'],
        components: {
            FilterSorting,
            ErrorMessage
        },
        data() {
            return {
                namaperfume: '',
                parfum: [],
                parfumsearch: [],
                idoutlet: this.setidoutlet,
                idparfum: '',
                keyparfum: 0,
                isClicked: true,
                searchKey: '',
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },

                parfumPagination: {
                    limit: 20,
                    offset: 0,
                    length: 0,
                    pageNumber: 0,
                    sortBy: "nama_parfum",
                    orderBy: "ASC",
                },
                parfumSearchPagination: {
                    limit: 20,
                    offset: 0,
                    length: 0,
                    pageNumber: 0,
                    sortBy: "nama_parfum",
                    orderBy: "ASC",
                    key: ""
                },
                parfumLength: 0,

                listParfumCalled: false,
            }
        },
        validations: {
            namaperfume: {
                required,
                minLength: minLength(2)
            }
        },
        mounted() {
            this.idoutlet = this.$route.params.idoutlet
            // $(".spinner").prop("style", "display:none");
            // $(".showPageSearch").prop("style", "display:none");
            $(".showPageSearch").hide()
            // this.getparfum()

            $('body').on('DOMSubtreeModified', '#listparfum', () => {
                if (!this.listParfumCalled) {
                    this.listParfumCalled = true
                    this.scroll()
                }
            });
        },
        methods: {
            scroll() {
                window.onscroll = () => {
                    if ($('#loadingSpinnerParfum').is(":hidden")) {
                        if ($(".showPageDefault").is(":visible")) {
                            if (this.parfumPagination.pageNumber <= Math.ceil(this.parfumPagination.length / this
                                    .parfumPagination.limit)) {
                                if (Math.floor($(window).scrollTop()) > 0 && Math.floor($(window).scrollTop()) >=
                                    Math.floor($(document).height() - $(window).height()) - 100) {
                                    this.parfumPagination.offset = (this.parfumPagination.pageNumber * this
                                        .parfumPagination.limit);
                                    this.getparfum();
                                    $('#loadingSpinnerParfum').show()
                                }
                            }
                        }
                    }
                }

                $("#list-search-parfum-scrolled").scroll(() => {
                    if ($(".showPageSearch").is(":visible")) {
                        if (this.parfumSearchPagination.pageNumber <= Math.ceil(this.parfumSearchPagination
                                .length / this.parfumSearchPagination.limit)) {
                            if (Math.floor($(window).scrollTop()) > 0 && Math.floor($(
                                    "#list-search-parfum-scrolled").scrollTop()) >= Math.floor($(
                                    "#list-search-parfum").height()) - $(document).height() - 100) {
                                this.parfumSearchPagination.offset = (this.parfumSearchPagination.pageNumber *
                                    this.parfumSearchPagination.limit);
                                this.searchRak();
                                $('#loadingSpinnerParfumSearch').show()
                            }
                        }
                    }
                })
            },

            back() {
                this.listParfumCalled = false
                this.parfumPagination = {
                    limit: 20,
                    offset: 0,
                    length: 0,
                    pageNumber: 0,
                    sortBy: "nama_parfum",
                    orderBy: "ASC",
                }
                this.parfumSearchPagination = {
                    limit: 20,
                    offset: 0,
                    length: 0,
                    pageNumber: 0,
                    sortBy: "nama_parfum",
                    orderBy: "ASC",
                    key: ""
                }
                this.$emit('isdetail')
            },
            modaledit(p, k) {
                this.keyparfum = k
                this.namaperfume = p.nama_parfum
                this.idparfum = p.idparfum
                if (p.parfum_default) {
                    $("#edit_default_parfum").prop("checked", true)
                } else {
                    $("#edit_default_parfum").prop("checked", false)
                }
                $('#editmodal').modal('show')
            },
            modaldel(p, k) {
                this.keyparfum = k
                this.idparfum = p.idparfum
                this.namaperfume = p.nama_parfum
                $('#deletemodalperfume').modal('show')
            },
            async addparfum() {
                if (this.$v.namaperfume.$invalid) {
                    this.$v.namaperfume.$touch()
                    this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
                    return
                }
                this.isClicked = true
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const addparfume = new FormData()
                    addparfume.append('nama_parfum', this.namaperfume)
                    addparfume.append('idoutlet', this.setidoutlet)
                    if ($("#create_default_parfum").is(":checked")) {
                        addparfume.append('parfum_default', 1)
                    } else {
                        addparfume.append('parfum_default', 0)
                    }
                    const response = await this.$axios.post(this.$baseurl +
                        '/masterData/parfum/create_parfum_outlet', addparfume, this.requestHeaders)
                    if (response.data.status === true) {
                        $('#loadingPage').removeClass('overlayLoading');
                        this.isClicked = false
                        this.getparfum(true)
                        this.namaperfume = ''
                        $("#create_default_parfum").prop("checked", false)
                        $("#addmodal").modal("hide")

                        this.$refs.errmsg.resetValidation()
                    } else {
                        this.$toast.error(response.data.msg)
                    }
                } catch (e) {
                    this.$catch_error_response(e)
                    this.isClicked = false
                    $('#loadingPage').removeClass('overlayLoading');
                }
            },
            async editparfum() {
                if (this.$v.namaperfume.$invalid) {
                    this.$v.namaperfume.$touch()
                    this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
                    return
                }
                this.isClicked = true;
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const editparfum = new FormData()
                    editparfum.append('nama_parfum', this.namaperfume)
                    if ($("#edit_default_parfum").is(":checked")) {
                        editparfum.append('parfum_default', 1)
                    } else {
                        editparfum.append('parfum_default', 0)
                    }
                    const response = await this.$axios.post(this.$baseurl +
                        '/masterData/parfum/update_parfum_outlet?idoutlet=' + this.setidoutlet + '&idparfum=' +
                        this.idparfum, editparfum, this.requestHeaders)
                    // this.rak[this.keyrak].nama =response.data.data
                    this.parfum[this.keyparfum].nama_parfum = response.data.data
                    $('#loadingPage').removeClass('overlayLoading');
                    this.isClicked = false
                    this.getparfum(true)
                    this.namaperfume = ''
                    $("#editmodal").modal("hide")
                } catch (e) {
                    this.$catch_error_response(e)
                    this.isClicked = false
                    $('#loadingPage').removeClass('overlayLoading');
                }
            },
            async delparfum() {
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
              try {
                  const delparfum = new FormData()
                  const response = await this.$axios.post(this.$baseurl + '/masterData/parfum/delete_parfum?idparfum=' + this.idparfum + "&idoutlet=" + this.setidoutlet, delparfum, this.requestHeaders)
                  if (response.data.status === true) {
                      $('#loadingPage').removeClass('overlayLoading');
                      $('#loadingPage').hide();
                      this.$toast.success(response.data.msg)
                      this.getparfum(true)
                      this.namaperfume=''
                      this.$refs.errmsg.resetValidation()
                  }else{
                      $('#loadingPage').hide();
                      $('#loadingPage').removeClass('overlayLoading');
                      this.$toast.error(response.data.msg)
                  }
              }  catch (e) {
              	  this.$catch_error_response(e)
	              $('#loadingPage').hide();
	              $('#loadingPage').removeClass('overlayLoading');
              }
            },

            async getparfum(refresh = false) {
                if (this.parfumPagination.offset === 0 || refresh) {
                    $('#loadingPage').show();
                    $('#loadingPage').addClass('overlayLoading');
                    this.parfum = [];
                    this.parfumPagination.offset = 0
                }
                var sort_get
                var order_get
                var limit
                var offset
                try {
                    sort_get = this.parfumPagination.sortBy;
                    order_get = this.parfumPagination.orderBy;
                    limit = this.parfumPagination.limit
                    offset = this.parfumPagination.offset
                    const response = await this.$axios.get(this.$baseurl +
                        '/masterData/meta/list_parfum_meta?sort_by=' + sort_get + '&order_by=' + order_get +
                        '&limit=' + limit + '&offset=' + offset + '&idoutlet=' + this.setidoutlet, this
                        .requestHeaders)
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            // this.parfum= response.data.data;
                            $('#loadingPage').hide();
                            $('#loadingPage').removeClass('overlayLoading');
                            this.parfumPagination.length += response.data.data.length
                            for (var i = 0; i < response.data.data.length; i++) {
                                this.parfum.push(response.data.data[i])
                            }
                            this.parfumLength = response.data.lenght_data
                            if (response.data.data.length > 0) {
                                $("#iconsearch").show()
                            } else {
                                $("#iconsearch").hide()
                            }
                        }
                        this.parfumPagination.pageNumber++
                        $('#loadingSpinnerParfum').hide()
                    }
                } catch (e) {
                    this.$catch_error_response(e)
                    $('#loadingSpinnerParfum').hide()
                    $('#loadingPage').hide();
                    $('#loadingPage').removeClass('overlayLoading');
                }
            },

            showSearch() {
                $(".showPageSearch").show()
                $(".showPageSearch").addClass("animated slideInDown")
                $("#textTopParfum").text("Minimal 2 karakter")
                $(".showPageDefault").hide();
                $("#input_search_parfume").focus();
            },
            closeSearch() {
                $(".showPageSearch").hide()
                $(".showPageSearch").removeClass("animated slideInDown")
                $(".showPageDefault").show();
                this.parfumsearch = "";
                this.searchKey = "";
                $("#textTopParfum").text("Minimal 2 karakter")

                this.parfumSearchPagination = {
                    limit: 20,
                    offset: 0,
                    length: 0,
                    pageNumber: 0,
                    sortBy: "nama_parfum",
                    orderBy: "ASC",
                    key: ""
                }
            },
            searchRak() {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    $(".spinner").prop("style", "display:inline-block");
                    this.searchRakFunc();
                }, 500);
            },

            async searchRakFunc() {
                var key = this.searchKey
                if (this.parfumSearchPagination.offset === 0 || this.parfumSearchPagination.key !== key) {
                    $("#textTopParfum").text("Sedang mencari...")
                    this.parfumSearchPagination = {
                        limit: 20,
                        offset: 0,
                        length: 0,
                        pageNumber: 0,
                        sortBy: "nama_parfum",
                        orderBy: "ASC",
                        key: key
                    }
                    this.parfumsearch = []
                }

                if (key.length >= 2) {
                    try {
                        const response = await this.$axios.get(this.$baseurl +
                            '/masterData/meta/list_parfum_meta?idoutlet=' + this.setidoutlet + '&key=' + key +
                            '&limit=' + this.parfumSearchPagination.limit + '&offset=' + this
                            .parfumSearchPagination.offset, this.requestHeaders)
                        // this.parfum= response.data.data
                        if (response.status === 200) {
                            if (response.data.status === true) {
                                this.parfumSearchPagination.length += response.data.data.length
                                if (response.data.data.length > 0) {
                                    $("#textTopParfum").text("Ditemukan " + response.data.data.length +
                                        " parfum dengan kata '" + key + "'");
                                } else {
                                    if (this.this.parfumSearchPagination.offset === 0) {
                                        $("#textTopParfum").text("Tidak menemukan '" + key + "'");
                                    }
                                }
                                // this.parfumsearch = response.data.data
                                for (var i = 0; i < response.data.data.length; i++) {
                                    this.parfumsearch.push(response.data.data[i])
                                }
                                $(".spinner").prop("style", "display:none");
                            }
                            this.parfumSearchPagination.pageNumber++
                            $('#loadingSpinnerParfumSearch').hide()
                        }
                    } catch (e) {
                        $('#loadingSpinnerParfumSearch').hide()
                        $(".spinner").prop("style", "display:none");
                    }
                } else {
                    $('#loadingSpinnerParfumSearch').hide()
                    this.parfumsearch = [];
                    $(".spinner").prop("style", "display:none");
                    $("#textTopParfum").text("Minimal 2 karakter")
                }
            },

            async selectSortingWorkshop(key) {
                $("#cardWorkshop").hide();
                $("#spinnerWorkshop").prop("style", "display:inline-block");
                switch (key) {
                    case "asc":
                        $('#dropdownMenuButton2').text("Urut Dari A - Z ")
                        this.getWorkshopSortingMaster(1)
                        break;
                    case "desc":
                        $('#dropdownMenuButton2').text("Urut Dari Z - A ")
                        this.getWorkshopSortingMaster(2)
                        break;
                    case "terbaru":
                        $('#dropdownMenuButton2').text("Urut Dari Terbaru ")
                        this.getWorkshopSortingMaster(3)
                        break;
                    case "terlama":
                        $('#dropdownMenuButton2').text("Urut Dari Terlama ")
                        this.getWorkshopSortingMaster(4)
                        break;
                    default:
                        $('#dropdownMenuButton2').text("Urutkan ")
                }
            },
            async getWorkshopSortingMaster(datasortingparfum) {
                var sort_by
                var order_by
                try {
                    if (datasortingparfum === 1) {
                        sort_by = "nama_parfum";
                        order_by = "ASC";
                    } else if (datasortingparfum === 2) {
                        sort_by = "nama_parfum";
                        order_by = "DESC";
                    } else if (datasortingparfum === 3) {
                        sort_by = "created_at";
                        order_by = "DESC";
                    } else if (datasortingparfum === 4) {
                        sort_by = "created_at";
                        order_by = "ASC";
                    } else {
                        return
                    }

                    //var key = jika ada search nanti dipake
                    var idowner = localStorage.getItem('idowner');
                    const res = await this.$axios.get(this.$baseurl +
                        '/masterData/meta/list_parfum_meta?idoutlet=' + this.setidoutlet + '&order_by=' +
                        order_by + '&sort_by=' + sort_by, this.requestHeaders)
                    if (res.status === 200) {
                        if (res.data.status === true) {
                            this.parfum = res.data.data
                            $("#spinnerWorkshop").prop("style", "display:none");
                            $("#cardWorkshop").show();
                        }
                    }
                } catch (e) {
                    this.$catch_error_response(e)
                    this.isClicked = false
                    $('#loadingPage').removeClass('overlayLoading');
                }
            },
            filter(payload) {
                this.parfumPagination = payload.data
                this.getparfum();
                setTimeout(() => {
                    $("#dropdownMenuButton-" + payload.type).html(payload.textSorting)
                }, 1000)
            },
            closeModalAdd() {
                this.namaperfume = '';
                this.$refs.errmsg.resetValidation()
            }
        }
    }
</script>

<style scoped>
    .image {
        margin-top: 185px;
        color: #333333;
        ;
    }



    #loading-bar-spinner.spinner {
        left: 50%;
        margin-left: -20px;
        top: 50%;
        margin-top: -20px;
        position: absolute;
        z-index: 19 !important;
        animation: loading-bar-spinner 400ms linear infinite;
    }

    #loading-bar-spinner.spinner .spinner-icon {
        width: 40px;
        height: 40px;
        border: solid 4px transparent;
        border-top-color: #a6a9a9 !important;
        border-left-color: #a6a9a9 !important;
        border-radius: 50%;
    }

    @keyframes loading-bar-spinner {
        0% {
            transform: rotate(0deg);
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    .card-2 {
        margin-top: 68px;
        margin-bottom: 100px;
    }

    .dropdown-menu.garis-parfum.show {
        left: 0 !important;
    }
</style>